import { render, staticRenderFns } from "./AddFaq.vue?vue&type=template&id=3ef887d3&"
import script from "./AddFaq.vue?vue&type=script&lang=js&"
export * from "./AddFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports